module.exports = __webpack_public_path__ + "img/f1.d79f33e2.png";